import { transactionStatus } from '@va/standalone/shared/constants';

export function getTransactionStatus(status: string, amount: number) {
  if (status === transactionStatus.REFUND || amount < 0) return 'refunded';
  if (status === transactionStatus.VOIDED) return 'voided';

  return 'paid';
}
